import { useState } from 'react';

// params* initialState Object - Initial values for the form fields.
export const useSampleRequestValueChange = (initialState = {}) => {
	const [requestValues, setRequestValues] = useState(initialState);
	const [errors, setErrors] = useState(null);

	const handleChange = (key, value) => {
		setRequestValues((prev) => ({
			...prev,
			[key]: value
		}));

		setErrors((prev) => ({
			...prev,
			[key]: ''
		}));
	};

	return {
		requestValues,
		errors,
		setRequestValues,
		handleChange,
		setErrors
	};
};
